import React from "react";
import { useTranslation } from "react-i18next";

import {
  PRIMARIES,
  ACCESSORIES,
  OLYMPICS,
  STRONGMAN,
} from "../../../../utils/exercise-catalog";

const PRIMARY_VALUE_TO_KEY = { bench: "benchPress" };

const getCategoryLabelKey = (value, isAccessory) => {
  if (isAccessory) {
    return value.toLowerCase();
  }
  return PRIMARY_VALUE_TO_KEY[value] || value;
};

const CatalogSelectors = ({
  onSelectorClick,
  filter,
  mobile,
  selectedExercises,
  search,
  onChangeFn,
}) => {
  const { t } = useTranslation("coaching-portal");
  const cat = (key) => t(`exerciseLibraryCatalog.categories.${key}`);

  return mobile ? (
    <div className="category-selectors">
      <header className="only-show-mobile">
        <input
          type="search"
          className="text-input search-exercise"
          name="search"
          placeholder={t("exerciseLibraryCatalog.searchPlaceholder")}
          value={search}
          onChange={onChangeFn}
          autoComplete="off"
        />
      </header>
      <ul>
        {ACCESSORIES.map((value) => {
          return (
            <li
              key={`accessory-${value}`}
              className={`category-item${filter === value ? " active" : ""}`}
              onClick={() => onSelectorClick(value)}
            >
              {cat(getCategoryLabelKey(value, true))}
            </li>
          );
        })}
        {PRIMARIES.map(({ value, label }) => {
          return (
            <li
              key={`primary-${value}`}
              className={`category-item${filter === value ? " active" : ""}`}
              onClick={() => onSelectorClick(value)}
            >
              {cat(getCategoryLabelKey(value, false))}
            </li>
          );
        })}
        {OLYMPICS.map(({ value, label }) => {
          return (
            <li
              key={`primary-${value}`}
              className={`category-item${filter === value ? " active" : ""}`}
              onClick={() => onSelectorClick(value)}
            >
              {cat(getCategoryLabelKey(value, false))}
            </li>
          );
        })}
        {STRONGMAN.map(({ value, label }) => {
          return (
            <li
              key={`primary-${value}`}
              className={`category-item${filter === value ? " active" : ""}`}
              onClick={() => onSelectorClick(value)}
            >
              {cat(getCategoryLabelKey(value, false))}
            </li>
          );
        })}
      </ul>
    </div>
  ) : (
    <aside>
      <fieldset>
        <legend>{t("exerciseLibraryCatalog.accessories")}</legend>
        <ul>
          {ACCESSORIES.map((value) => {
            let count = 0;
            selectedExercises.assistant.forEach((ex) => {
              if (ex.primaryMuscleGroup === value) count++;
              if (value === "Other" && !ex.primaryMuscleGroup) count++;
            });
            return (
              <li key={`accessory-${value}`}>
                <button
                  data-button-type={filter === value ? "primary" : "text-white"}
                  onClick={() => onSelectorClick(value)}
                >
                  {cat(getCategoryLabelKey(value, true))}{" "}
                  {count ? <span>{count}</span> : null}
                </button>
              </li>
            );
          })}
        </ul>
      </fieldset>

      <fieldset>
        <legend>{t("exerciseLibraryCatalog.powerlifting")}</legend>
        <ul>
          {PRIMARIES.map(({ value, label }) => {
            return (
              <li
                key={`primary-${value}`}
                className={`category-item${filter === value ? " active" : ""}`}
              >
                <button
                  data-button-type={filter === value ? "primary" : "text-white"}
                  onClick={() => onSelectorClick(value)}
                >
                  {cat(getCategoryLabelKey(value, false))}

                  {selectedExercises[value].length ? (
                    <span>{selectedExercises[value].length}</span>
                  ) : null}
                </button>
              </li>
            );
          })}
        </ul>
      </fieldset>

      <fieldset>
        <legend>{t("exerciseLibraryCatalog.olympicWeightlifting")}</legend>
        <ul>
          {OLYMPICS.map(({ value, label }) => {
            return (
              <li
                key={`primary-${value}`}
                className={`category-item${filter === value ? " active" : ""}`}
              >
                <button
                  data-button-type={filter === value ? "primary" : "text-white"}
                  onClick={() => onSelectorClick(value)}
                >
                  {cat(getCategoryLabelKey(value, false))}

                  {selectedExercises[value].length ? (
                    <span>{selectedExercises[value].length}</span>
                  ) : null}
                </button>
              </li>
            );
          })}
        </ul>
      </fieldset>

      <fieldset>
        <legend>{t("exerciseLibraryCatalog.strongmanOther")}</legend>
        <ul>
          {STRONGMAN.map(({ value, label }) => {
            return (
              <li
                key={`primary-${value}`}
                className={`category-item${filter === value ? " active" : ""}`}
              >
                <button
                  data-button-type={filter === value ? "primary" : "text-white"}
                  onClick={() => onSelectorClick(value)}
                >
                  {cat(getCategoryLabelKey(value, false))}

                  {selectedExercises[value].length ? (
                    <span>{selectedExercises[value].length}</span>
                  ) : null}
                </button>
              </li>
            );
          })}
        </ul>
      </fieldset>
    </aside>
  );
};

export default CatalogSelectors;
